var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { space } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import { Flex } from '../Flex';
import { Hide } from '../Hide';
import { Box } from '../Box';
import { applyVariations, getPaletteColor, hasPaletteColor, color, deprecatedColorValue, deprecatedPropType, } from '../utils';
var capitalize = function (str) { return str.charAt(0).toUpperCase() + str.slice(1); };
var shadowColor = function (props) {
    var darkColor = hasPaletteColor(props)
        ? getPaletteColor('dark')(props)
        : themeGet("colors.dark".concat(capitalize(props.color)))(props);
    return {
        backgroundImage: !darkColor
            ? "\n        linear-gradient(45deg, transparent 50%, rgba(0, 0, 0, 0.5) 50%),\n        linear-gradient(45deg, transparent 50%, ".concat(props.color, " 50%)\n      ")
            : "linear-gradient(45deg, transparent 50%, ".concat(darkColor, " 50%)"),
    };
};
var FlagShadow = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 8px;\n  height: 8px;\n  align-self: flex-end;\n  background-color: inherit;\n  ", ";\n  position: absolute;\n  bottom: 0;\n"], ["\n  width: 8px;\n  height: 8px;\n  align-self: flex-end;\n  background-color: inherit;\n  ", ";\n  position: absolute;\n  bottom: 0;\n"])), shadowColor);
var FlagRight = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: none;\n  background-color: ", ";\n  border-radius: 0 ", " ", " 0;\n  /* for 32 x 8 triangle */\n  transform: skew(-14deg);\n  position: relative;\n  z-index: 1;\n"], ["\n  flex: none;\n  background-color: ", ";\n  border-radius: 0 ", " ", " 0;\n  /* for 32 x 8 triangle */\n  transform: skew(-14deg);\n  position: relative;\n  z-index: 1;\n"])), function (props) { return getPaletteColor('base')(props) || props.color; }, themeGet('radius'), themeGet('radius'));
var flexAuto = function (props) {
    return props.flexAuto
        ? {
            flex: '1 1 auto',
        }
        : null;
};
var FlagBody = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", "px;\n  border-radius: 0 0 ", " 0;\n  ", " ", ";\n  z-index: 2;\n"], ["\n  font-size: ", "px;\n  border-radius: 0 0 ", " 0;\n  ", " ", ";\n  z-index: 2;\n"])), themeGet('fontSizes.0'), themeGet('radius'), flexAuto, color);
var RelativeHide = styled(Hide)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledFlex = styled(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), applyVariations('Flag'));
var propTypes = __assign({ color: deprecatedColorValue(), bg: deprecatedPropType('color') }, space.propTypes);
var Flag = function (_a) {
    var color = _a.color, bg = _a.bg, children = _a.children, pl = _a.pl, pr = _a.pr, py = _a.py, width = _a.width, props = __rest(_a, ["color", "bg", "children", "pl", "pr", "py", "width"]);
    return (React.createElement(StyledFlex, __assign({ width: width }, props, { ml: [0, -2] }),
        React.createElement(RelativeHide, { xs: true },
            React.createElement(FlagShadow, { width: '4px', mr: -2, mb: -2, color: hasPaletteColor(__assign({ color: color }, props)) ? color : bg })),
        React.createElement(FlagBody, { flexAuto: !!width, color: color, bg: hasPaletteColor(__assign({ color: color }, props)) ? false : bg, pl: pl, pr: pr, py: py }, children),
        React.createElement(FlagRight, { width: '18px', color: hasPaletteColor(__assign({ color: color }, props)) ? color : bg, ml: -2 })));
};
Flag.propTypes = propTypes;
Flag.defaultProps = {
    color: 'white',
    bg: 'green',
    pl: [1, 3],
    pr: null,
    py: [1, 2],
};
Flag.displayName = 'Flag';
export default withTheme(Flag);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Flag.js.map